import { ControlBase } from '@components/dynamic-form/control-base';
import { ControlType } from '@components/dynamic-form/control-type';
import { FormSetting } from '@/form-settings/form-setting';
import { Validators } from '@angular/forms';
import { DropdownControl } from '@components/dynamic-form/dropdown/dropdown-control';

export class GaragePassageFormMeta extends FormSetting {
  protected static classToCall: string;
  private static rows: ControlBase[] = [];
  // Email validation pattern
  private static emailPattern = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$';

  public static getMeta(
    enableStatoConsegnaVgi: boolean = false,
    enableRivenditoreEsterno: boolean = false,
    enableResponsabileVenditoreInterno: boolean = false,
    enableWhatsappSender: boolean = false,
  ): Array<any> {
    this.rows = [];

    this.addRowId();
    this.addRowReparto();
    this.addRowTipoVendita();
    this.addRowNumeroPratica();
    this.addRowDataDocumento();
    this.addRowMarca();
    this.addRowModello();
    this.addRowTarga();
    this.addRowTelaio();
    this.addRowBpCliente();
    this.addRowDenominazioneCliente();
    this.addRowEmailCliente();

    // Only modifiable fields at the top
    this.addModifiableEmailFields(
      enableStatoConsegnaVgi,
      enableRivenditoreEsterno,
      enableResponsabileVenditoreInterno,
      enableWhatsappSender,
    );
    this.addRowStatoRecord();
    this.addRowValid();
    this.addRowValidWhatsapp();

    return [
      {
        rows: this.rows,
        order: 1,
      },
    ];
  }

  // Group all modifiable email fields at the top
  private static addModifiableEmailFields(
    enableStatoConsegnaVgi: boolean = false,
    enableRivenditoreEsterno: boolean = false,
    enableResponsabileVenditoreInterno: boolean = false,
    enableWhatsappSender: boolean = false,
  ) {
    // Denominazione Utilizzatore (autocomplete utilizzatori)
    const denominazioneUtilizzatoreComponent = {} as ControlBase;
    denominazioneUtilizzatoreComponent.key = 'denominazioneUtilizzatore';
    denominazioneUtilizzatoreComponent.controlType = 'autocomplete-utilizzatore' as any;
    denominazioneUtilizzatoreComponent.disabled = false;
    denominazioneUtilizzatoreComponent.label = 'Denominazione Utilizzatore';
    denominazioneUtilizzatoreComponent.class = 'w-9/12';
    denominazioneUtilizzatoreComponent.classToUse = 'GaragePassageDetailFormComponent';
    denominazioneUtilizzatoreComponent.customAction = 'onUtilizzatoreSelected';
    this.rows.push(denominazioneUtilizzatoreComponent);

    // BP Email
    const bpEmailComponent = {} as ControlBase;
    bpEmailComponent.key = 'bpEmail';
    bpEmailComponent.controlType = ControlType.textInput;
    bpEmailComponent.disabled = false;
    bpEmailComponent.label = 'BP Utilizzatore';
    bpEmailComponent.class = 'w-3/12';
    this.rows.push(bpEmailComponent);

    // Email (main email)
    const emailComponent = {} as ControlBase;
    emailComponent.key = 'email';
    emailComponent.controlType = ControlType.textInput;
    emailComponent.disabled = false;
    emailComponent.label = 'Email Utilizzatore';
    emailComponent.class = 'w-full';
    emailComponent.required = true;
    emailComponent.validators = [Validators.pattern(this.emailPattern)];
    emailComponent.errorMessage = 'Inserire un indirizzo email valido';
    this.rows.push(emailComponent);

    // Codice venditore interno
    const codiceVenditoreInternoComponent = {} as ControlBase;
    codiceVenditoreInternoComponent.key = 'codiceVenditoreInterno';
    codiceVenditoreInternoComponent.controlType = ControlType.textInput;
    codiceVenditoreInternoComponent.disabled = true;
    codiceVenditoreInternoComponent.required = false;
    codiceVenditoreInternoComponent.label = 'Codice Venditore';
    codiceVenditoreInternoComponent.class = 'w-4/12';
    this.rows.push(codiceVenditoreInternoComponent);

    // Resp Cliente Email
    const respClienteEmailComponent = {} as ControlBase;
    respClienteEmailComponent.key = 'respClienteEmail';
    respClienteEmailComponent.controlType = ControlType.textInput;
    respClienteEmailComponent.disabled = false;
    respClienteEmailComponent.required = true;
    respClienteEmailComponent.label = 'Responsabile Cliente/Venditore';
    respClienteEmailComponent.class = 'w-4/12';
    this.rows.push(respClienteEmailComponent);

    // Resp Cliente indirizzo Email
    const respClienteIndirizzoEmailComponent = {} as ControlBase;
    respClienteIndirizzoEmailComponent.key = 'respClienteIndirizzoEmail';
    respClienteIndirizzoEmailComponent.controlType = ControlType.textInput;
    respClienteIndirizzoEmailComponent.disabled = !enableResponsabileVenditoreInterno;
    respClienteIndirizzoEmailComponent.required = enableResponsabileVenditoreInterno;
    respClienteIndirizzoEmailComponent.validators = [Validators.pattern(this.emailPattern)];
    respClienteIndirizzoEmailComponent.errorMessage = 'Inserire un indirizzo email valido';
    respClienteIndirizzoEmailComponent.label = 'Responsabile venditore indirizzo email';
    respClienteIndirizzoEmailComponent.class = 'w-4/12';
    this.rows.push(respClienteIndirizzoEmailComponent);

    // telefono Utilizzatore
    const telefonoUtilizzatoreComponent = {} as ControlBase;
    telefonoUtilizzatoreComponent.key = 'telefonoUtilizzatore';
    telefonoUtilizzatoreComponent.controlType = ControlType.textInput;
    telefonoUtilizzatoreComponent.disabled = !enableWhatsappSender;
    telefonoUtilizzatoreComponent.required = enableWhatsappSender;
    telefonoUtilizzatoreComponent.label = 'Cellulare utilizzatore (NO FISSO)';
    telefonoUtilizzatoreComponent.class = 'w-4/12';
    this.rows.push(telefonoUtilizzatoreComponent);

    // Venditore esterno - conditionally enabled/disabled
    const venditoreEsternoComponent = {} as ControlBase;
    venditoreEsternoComponent.key = 'rivenditoreEsterno';
    venditoreEsternoComponent.controlType = ControlType.textInput;
    venditoreEsternoComponent.disabled = !enableRivenditoreEsterno;
    venditoreEsternoComponent.required = enableRivenditoreEsterno;
    venditoreEsternoComponent.label = 'Rivenditore esterno';
    venditoreEsternoComponent.class = 'w-4/12';
    this.rows.push(venditoreEsternoComponent);

    const statoConsegnaVgiComponent = {} as DropdownControl;
    statoConsegnaVgiComponent.key = 'statoConsegnaVgi';
    statoConsegnaVgiComponent.controlType = ControlType.dropdown;
    statoConsegnaVgiComponent.options = [
      { key: 'INVIATO_VGI', value: 'INVIATO_VGI' },
      { key: 'NON_INVIATO_VGI', value: 'NON_INVIATO_VGI' },
    ];
    statoConsegnaVgiComponent.disabled = !enableStatoConsegnaVgi;
    statoConsegnaVgiComponent.required = enableStatoConsegnaVgi;
    statoConsegnaVgiComponent.label = 'Stato Consegna';
    statoConsegnaVgiComponent.class = 'w-2/12';
    this.rows.push(statoConsegnaVgiComponent);
  }

  // All methods below create read-only fields
  private static addRowId() {
    const inputComponent = {} as ControlBase;
    inputComponent.key = 'id';
    inputComponent.controlType = ControlType.textInput;
    inputComponent.disabled = true;
    inputComponent.label = 'ID';
    inputComponent.class = 'w-3/12';
    this.rows.push(inputComponent);
  }

  private static addRowReparto() {
    const inputComponent = {} as ControlBase;
    inputComponent.key = 'reparto';
    inputComponent.controlType = ControlType.textInput;
    inputComponent.disabled = true;
    inputComponent.label = 'Reparto';
    inputComponent.class = 'w-3/12';
    this.rows.push(inputComponent);
  }

  private static addRowTipoVendita() {
    const inputComponent = {} as ControlBase;
    inputComponent.key = 'tipoVendita';
    inputComponent.controlType = ControlType.textInput;
    inputComponent.disabled = true;
    inputComponent.label = 'Tipo vendita';
    inputComponent.class = 'w-3/12';
    this.rows.push(inputComponent);
  }

  private static addRowMarca() {
    const inputComponent = {} as ControlBase;
    inputComponent.key = 'marca';
    inputComponent.controlType = ControlType.textInput;
    inputComponent.disabled = true;
    inputComponent.label = 'Marca';
    inputComponent.class = 'w-3/12';
    this.rows.push(inputComponent);
  }

  private static addRowModello() {
    // Modello Email
    const modelloEmailComponent = {} as ControlBase;
    modelloEmailComponent.key = 'modelloEmail';
    modelloEmailComponent.controlType = ControlType.textInput;
    modelloEmailComponent.disabled = false;
    modelloEmailComponent.label = 'Modello';
    modelloEmailComponent.class = 'w-6/12';
    this.rows.push(modelloEmailComponent);
  }

  private static addRowNumeroPratica() {
    const inputComponent = {} as ControlBase;
    inputComponent.key = 'numeroPratica';
    inputComponent.controlType = ControlType.textInput;
    inputComponent.disabled = true;
    inputComponent.label = 'Numero Pratica';
    inputComponent.class = 'w-3/12';
    this.rows.push(inputComponent);
  }

  private static addRowDataDocumento() {
    const inputComponent = {} as ControlBase;
    inputComponent.key = 'dataDocumento';
    inputComponent.controlType = ControlType.date;
    inputComponent.disabled = true;
    inputComponent.label = 'Data Documento';
    inputComponent.class = 'w-3/12';
    this.rows.push(inputComponent);
  }

  private static addRowTarga() {
    const inputComponent = {} as ControlBase;
    inputComponent.key = 'targa';
    inputComponent.controlType = ControlType.textInput;
    inputComponent.disabled = true;
    inputComponent.label = 'Targa';
    inputComponent.class = 'w-3/12';
    this.rows.push(inputComponent);
  }

  private static addRowTelaio() {
    const inputComponent = {} as ControlBase;
    inputComponent.key = 'telaio';
    inputComponent.controlType = ControlType.textInput;
    inputComponent.disabled = true;
    inputComponent.label = 'Telaio';
    inputComponent.class = 'w-3/12';
    this.rows.push(inputComponent);
  }

  private static addRowBpCliente() {
    const inputComponent = {} as ControlBase;
    inputComponent.key = 'nrBpCliente';
    inputComponent.controlType = ControlType.textInput;
    inputComponent.disabled = true;
    inputComponent.label = 'BP Cliente';
    inputComponent.class = 'w-3/12';
    this.rows.push(inputComponent);
  }

  private static addRowDenominazioneCliente() {
    const inputComponent = {} as ControlBase;
    inputComponent.key = 'denominazioneCliente';
    inputComponent.controlType = ControlType.textInput;
    inputComponent.disabled = true;
    inputComponent.label = 'Denominazione Cliente';
    inputComponent.class = 'w-6/12';
    this.rows.push(inputComponent);
  }

  private static addRowEmailCliente() {
    const inputComponent = {} as ControlBase;
    inputComponent.key = 'emailCliente';
    inputComponent.controlType = ControlType.textInput;
    inputComponent.disabled = true;
    inputComponent.label = 'Email Cliente';
    inputComponent.class = 'w-6/12';
    this.rows.push(inputComponent);
  }

  private static addRowStatoRecord() {
    const inputComponent = {} as ControlBase;
    inputComponent.key = 'statoRecord';
    inputComponent.controlType = ControlType.textInput;
    inputComponent.disabled = true;
    inputComponent.label = 'Stato Record';
    inputComponent.class = 'w-2/12';
    this.rows.push(inputComponent);
  }

  private static addRowValid() {
    const inputComponent = {} as ControlBase;
    inputComponent.key = 'valid';
    inputComponent.controlType = ControlType.slideToggle;
    inputComponent.disabled = true;
    inputComponent.label = 'Valido';
    inputComponent.class = 'w-2/12';
    this.rows.push(inputComponent);
  }

  private static addRowValidWhatsapp() {
    const inputComponent = {} as ControlBase;
    inputComponent.key = 'validWhatsapp';
    inputComponent.controlType = ControlType.slideToggle;
    inputComponent.disabled = true;
    inputComponent.label = 'Valido Whatsapp';
    inputComponent.class = 'w-2/12';
    this.rows.push(inputComponent);
  }
}
